import {
  ApplicationPaths,
  LoginActions,
  QueryParameterNames,
} from "./ApiAuthorizationConstants";

import { AuthenticationResultStatus } from "./AuthorizeService";
import { Component } from "react";
import Loading from "../common/Loading";
import React from "react";
import authService from "./AuthorizeService";

// The main responsibility of this component is to handle the user's login process.
// This is the starting point for the login process. Any component that needs to authenticate
// a user can simply perform a redirect to this component with a returnUrl query parameter and
// let the component perform the login and return back to the return url.
export class Login extends Component {
  constructor(props) {
    super(props);

    this.state = {
      message: undefined,
    };
  }

  async componentDidMount() {
    const action = this.props.action;
    switch (action) {
      case LoginActions.Login:
        this.login();
        break;
      case LoginActions.LoginCallback:
        this.processLoginCallback();
        break;
      case LoginActions.LoginFailed:
        const params = new URLSearchParams(window.location.search);
        const error = params.get(QueryParameterNames.Message);
        this.setState({ message: error });
        break;
      case LoginActions.Profile:
        this.redirectToProfile();
        break;
      case LoginActions.Register:
        this.redirectToRegister();
        break;
      default:
        throw new Error(`Invalid action '${action}'`);
    }
  }

  render() {
    const action = this.props.action;
    const { message } = this.state;

    if (!!message) {
      return <div>{message}</div>;
    } else {
      switch (action) {
        case LoginActions.Login:
          return <Loading />;
        case LoginActions.LoginCallback:
          return <Loading />;
        case LoginActions.Profile:
        case LoginActions.Register:
          return <Loading />;
        default:
          throw new Error(`Invalid action '${action}'`);
      }
    }
  }

  async login(returnUrl) {
    const state = { returnUrl };
    const result = await authService.signIn(state);
    switch (result.status) {
      case AuthenticationResultStatus.Redirect:
        break;
      case AuthenticationResultStatus.Success:
        await this.navigateToReturnUrl();
        break;
      case AuthenticationResultStatus.Fail:
        const message = result?.message?.message
          ? result.message.message
          : result.message;
        this.setState({ message: message });
        await this.navigateToReturnUrl();
        break;
      default:
        throw new Error(`Invalid status result ${result.status}.`);
    }
  }

  async processLoginCallback() {
    const url = window.location.href;
    const result = await authService.completeSignIn(url);
    switch (result.status) {
      case AuthenticationResultStatus.Redirect:
        // There should not be any redirects as the only time completeSignIn finishes
        // is when we are doing a redirect sign in flow.
        throw new Error("Should not redirect.");
      case AuthenticationResultStatus.Success:
        await this.navigateToReturnUrl();
        break;
      case AuthenticationResultStatus.Fail:
        this.setState({ message: result.message });
        break;
      default:
        throw new Error(
          `Invalid authentication result status '${result.status}'.`
        );
    }
  }

  redirectToRegister() {
    this.redirectToApiAuthorizationPath(
      `${ApplicationPaths.IdentityRegisterPath}?${
        QueryParameterNames.ReturnUrl
      }=${encodeURI(ApplicationPaths.Login)}`
    );
  }

  redirectToProfile() {
    this.redirectToApiAuthorizationPath(ApplicationPaths.IdentityManagePath);
  }

  redirectToApiAuthorizationPath(apiAuthorizationPath) {
    const redirectUrl = `${window.location.origin}/${apiAuthorizationPath}`;
    // It's important that we do a replace here so that when the user hits the back arrow on the
    // browser they get sent back to where it was on the app instead of to an endpoint on this
    // component.
    window.location.replace(redirectUrl);
  }

  doNothing() {
    return;
  }

  async navigateToReturnUrl() {
    await authService.isAuthenticated().then(async (isAuthenticated) => {
      if (isAuthenticated) {
        const isCustomer = await authService.isCustomer();
        const isLead = await authService.isLead();
        const isSchedulingManager = await authService.isSchedulingManager();
        const isInvoicingManager = await authService.isInvoicingManager();
        const isEmployee = await authService.isEmployee();
        const isQCManager = await authService.isQCManager();
        const isUpperManagement = await authService.isUpperManagement();

        if (isCustomer) {
          window.location.replace(
            `${window.location.origin}/manage-customer-jobs`
          );
        } else if (isEmployee) {
          window.location.replace(`${window.location.origin}/my-profile`);
        } else if (isLead) {
          window.location.replace(`${window.location.origin}/daily-sheet`);
        } else if (isSchedulingManager) {
          window.location.replace(
            `${window.location.origin}/manage-customer-jobs`
          );
        } else if (isInvoicingManager) {
          window.location.replace(
            `${window.location.origin}/invoicing/invoice-status`
          );
        } else if (isQCManager) {
          window.location.replace(
            `${window.location.origin}/quality-control-check-status`
          );
        } else if (isUpperManagement) {
          window.location.replace(`${window.location.origin}/contracts/profitandlossreporting`)
        } else {
          window.location.replace(`${window.location.origin}/complexes`);
        }
      } else {
        window.location.replace(`${window.location.origin}/Account/Login`);
      }
    });
  }
}
